"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportSamOrder = exportSamOrder;
exports.getIntegralLog = getIntegralLog;
exports.getOrderStatusGrouped = getOrderStatusGrouped;
exports.getSamOrderDetail = getSamOrderDetail;
exports.getSamOrderList = getSamOrderList;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 山姆订单列表
 */
function getSamOrderList(params) {
  return (0, _request.default)({
    url: '/admin/lyp/order/sm/list',
    method: 'POST',
    data: params || {}
  });
}

/**
 * 订单状态（分组）
 */
function getOrderStatusGrouped() {
  return (0, _request.default)({
    url: '/admin/lyp/order/order-status/grouped',
    method: 'POST'
  });
}

/**
 * 山姆订单导出
 */
function exportSamOrder(params) {
  return (0, _request.default)({
    url: '/admin/sm/order/export',
    method: 'GET',
    params: params
  });
}

/**
 * 山姆订单详情
 */
function getSamOrderDetail(orderNo) {
  return (0, _request.default)({
    url: '/admin/lyp/order/sm/detail',
    method: 'POST',
    data: {
      orderNo: orderNo
    }
  });
}

/**
 * 积分/福豆使用明细
 * @param {string|number} orderNo 订单号
 */
function getIntegralLog(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/station/getIntegralLog/".concat(orderNo),
    method: 'get'
  });
}